//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TippyComponent as Tippy } from 'vue-tippy';

import { version } from '../../package.json';

export default {
  components: {
    Tippy
  },
  props: {
    trigger: {
      type: String,
      default: 'click'
    },
    maxWidth: {
      type: [Number, String],
      default: 350
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    theme: {
      type: String,
      default: 'light'
    },
    arrow: {
      type: Boolean,
      default: false
    },
    distance: {
      type: Number,
      default: 10
    },
    disabled: Boolean,
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    version
  }),
  watch: {
    disable() {
      const { disabled } = this;
      const { tip } = this.$refs.tippy;

      if (disabled) tip.disable();
      if (!disabled) tip.enable();
    }
  },
  mounted() {
    const { disabled } = this;
    const { tip } = this.$refs.tippy;

    if (disabled) tip.disable();
  },
  methods: {
    close() {
      const { tip } = this.$refs.tippy;

      tip.hide();
    },
    show() {
      const { tip } = this.$refs.tippy;
      tip.show();
    },
    emit({ name, type }) {
      this.$emit(name, { type });
    }
  }
};
